// src/pages/Appli/AppliAdmin/clubs-admin/components/ClubsTableDesktop.jsx

import React from "react";

import {
  AdherentCountEditor,
  ClubActionButtons,
  ClubLogo,
  ContactBlock,
  DepartmentBadge,
} from "./ClubCells";

export default function ClubsTableDesktop({
  rows,
  loading,

  deletingId,

  memberCountsByClub,
  memberCountsLoadingByClub,

  adherentCountsSavingByClub,
  onSaveAdherentCount,

  onMembers,
  onEdit,
  onDelete,
}) {
  return (
    <div className="hidden overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900 lg:block">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-left text-slate-600 dark:bg-slate-950/50 dark:text-slate-300">
            <tr>
              <th className="w-[70px] px-3 py-3 font-semibold">
                Logo
              </th>

              <th className="min-w-[210px] px-3 py-3 font-semibold">
                Club
              </th>

              <th className="px-3 py-3 font-semibold">
                Département
              </th>

              <th className="w-[170px] px-3 py-3 font-semibold">
                Licenciés
              </th>

              <th className="w-[240px] px-3 py-3 font-semibold">
                Adresse
              </th>

              <th className="min-w-[220px] px-3 py-3 font-semibold">
                Contacts
              </th>

              <th className="min-w-[210px] px-3 py-3 text-center font-semibold">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
            {loading ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-10 text-center text-slate-500"
                >
                  Chargement des clubs…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-10 text-center text-slate-500"
                >
                  Aucun club ne correspond aux filtres.
                </td>
              </tr>
            ) : (
              rows.map((club) => (
                <tr
                  key={club.id}
                  className="align-top transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-3 py-3">
                    <ClubLogo
                      src={club.logo_url}
                      alt={club.nom_club}
                    />
                  </td>

                  <td className="px-3 py-3">
                    <p className="font-semibold text-slate-900 dark:text-white">
                      {club.nom_club || "Club sans nom"}
                    </p>

                    {club.numero_club ? (
                      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                        N° club : {club.numero_club}
                      </p>
                    ) : null}
                  </td>

                  <td className="px-3 py-3">
                    <DepartmentBadge>
                      {club.departement_club || "?"}
                    </DepartmentBadge>
                  </td>

                  <td className="px-3 py-3">
                    <div className="w-[165px]">
                      <AdherentCountEditor
                        club={club}
                        saving={Boolean(
                          adherentCountsSavingByClub[
                            club.id
                          ],
                        )}
                        onSave={onSaveAdherentCount}
                      />
                    </div>
                  </td>

                  <td className="px-3 py-3">
                    <div
                      className="w-[240px] whitespace-normal break-words text-[13px] leading-snug text-slate-700 dark:text-slate-200"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                      title={club.adresse_club || ""}
                    >
                      {club.adresse_club ||
                        "Adresse non renseignée"}
                    </div>
                  </td>

                  <td className="px-3 py-3">
                    <ContactBlock club={club} />
                  </td>

                  <td className="px-3 py-3">
                    <ClubActionButtons
                      club={club}
                      memberCount={
                        memberCountsByClub[club.id]
                      }
                      memberCountLoading={Boolean(
                        memberCountsLoadingByClub[
                          club.id
                        ],
                      )}
                      onMembers={onMembers}
                      onEdit={onEdit}
                      onDelete={onDelete}
                      deletingId={deletingId}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}